import { authService } from './authService';
import { NewRequestFormData } from '../pages/employees/leaves/NewRequestDialog';

const LEAVE_API_URL = '/api/leave-requests/';

export const leaveService = {
  getLeaveRequests: async (filters?: any) => {
    const token = authService.getAccessToken();
    
    let url = LEAVE_API_URL;
    if (filters) {
      const queryParams = new URLSearchParams(filters).toString();
      url = `${url}?${queryParams}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
      },
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la récupération des demandes');
    }
    return response.json();
  },
  // Nouvelle méthode pour mettre à jour une demande (brouillon)
  updateLeaveRequest: async (id: number | string, data: NewRequestFormData) => {
    const token = authService.getAccessToken();
    const response = await fetch(`${LEAVE_API_URL}${id}/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.detail || errData.message || 'Erreur lors de la mise à jour de la demande.');
    }
    return response.json();
  },
  updateLeaveStatus: async (id: number, status: 'approved' | 'rejected') => {
    const token = authService.getAccessToken();
    const response = await fetch(`${LEAVE_API_URL}${id}/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({ status }),
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.detail || 'Erreur lors de la mise à jour');
    }
    return response.json();
  },

  submitLeaveRequest: async (id: number) => {
    const token = authService.getAccessToken();
    const response = await fetch(`${LEAVE_API_URL}${id}/submit/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
      },
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.detail || 'Erreur lors de la soumission');
    }
    return response.json();
  },

  approveLeaveRequest: async (id: number) => {
    const token = authService.getAccessToken();
    const response = await fetch(`${LEAVE_API_URL}${id}/approve/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
      },
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.detail || "Erreur lors de l'approbation");
    }
    return response.json();
  },

  rejectLeaveRequest: async (id: number, managerNote?: string) => {
    const token = authService.getAccessToken();
    const response = await fetch(`${LEAVE_API_URL}${id}/reject/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({ manager_note: managerNote || '' }),
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.detail || 'Erreur lors du refus');
    }
    return response.json();
  },
deleteLeaveRequest: async (id: number | string): Promise<void> => {
    const token = authService.getAccessToken();
    const response = await fetch(`/api/leave-requests/${id}/`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || 'Erreur lors de la suppression de la demande.');
    }
  },
};